/* components/Intro.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	space
} from "svelte/internal";

import { route } from "~/stores/router";

function create_fragment(ctx) {
	let p;
	let t1;
	let div;
	let button0;
	let t3;
	let button1;
	let dispose;

	return {
		c() {
			p = element("p");
			p.textContent = "Super Labeler is a Github Action that automatically labels your repo's issues\n  and pull requests. Super Labeler uses a declarative configuration that allows\n  you to easily manage your labels and when to apply them. This configuration\n  file is checked in to your repository, just like the rest of your CI config.";
			t1 = space();
			div = element("div");
			button0 = element("button");
			button0.textContent = "Create a new config";
			t3 = space();
			button1 = element("button");
			button1.textContent = "Import an existing config";
			attr(p, "class", "ml-3 mr-3");
			attr(button0, "class", "btn btn-primary");
			attr(button0, "type", "button");
			attr(button1, "class", "btn");
			attr(button1, "type", "button");
			attr(div, "class", "text-center");
		},
		m(target, anchor, remount) {
			insert(target, p, anchor);
			insert(target, t1, anchor);
			insert(target, div, anchor);
			append(div, button0);
			append(div, t3);
			append(div, button1);
			if (remount) dispose();
			dispose = listen(button0, "click", /*handleNewConfig*/ ctx[0]);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(p);
			if (detaching) detach(t1);
			if (detaching) detach(div);
			dispose();
		}
	};
}

function instance($$self) {
	const handleNewConfig = () => route.set("/labels");
	return [handleNewConfig];
}

class Intro extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Intro;